// TelcoTrack - Error State Component
// Reusable error state component for displaying error messages

import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-error-state',
  template: `
    <div class="error-state text-center py-16">
      <div class="text-error text-6xl mb-4">{{ icon }}</div>
      <h3 *ngIf="title" class="text-xl font-semibold text-primary mb-2">{{ title }}</h3>
      <p *ngIf="message" class="text-secondary mb-4">{{ message }}</p>
      <div *ngIf="showRetry" class="mt-6">
        <app-button variant="primary" (onClick)="onRetry()">
          {{ retryText }}
        </app-button>
      </div>
      <div *ngIf="showAction" class="mt-6">
        <ng-content select="[slot=action]"></ng-content>
      </div>
    </div>
  `,
  styles: []
})
export class ErrorStateComponent {
  @Input() icon: string = '⚠️';
  @Input() title: string = 'Chyba při načítání';
  @Input() message: string = '';
  @Input() showRetry: boolean = true;
  @Input() retryText: string = 'Zkusit znovu';
  @Input() showAction: boolean = false;

  @Output() retry = new EventEmitter<void>();

  onRetry(): void {
    this.retry.emit();
  }
}

